import React, { Component } from 'react';
import { connect } from 'react-redux';
import {bindActionCreators} from 'redux';
import SeatsioChartContainer from './SeatsioChartContainer'
import SeatingChartCartInventory from './SeatingChartCartInventory';
import SeatingChartTicketPickerTotals from './SeatingChartTicketPickerTotals';
import CheckoutButton from '../../ticket-picker/containers/CheckoutButton';
import InventoryErrors from '../../ticket-picker/containers/InventoryErrors';
import FeeDisclosure from '../../ticket-picker/containers/FeeDisclosure';
import CouponEntryButton from '../../ticket-picker/containers/CouponEntryButton';
import ChangeDateContainer from '../../ticket-picker/containers/ChangeDateContainer';
import ProductWrapper from '../../product-picker/containers/ProductWrapper';
import { reservationActive } from '../../../selectors/reservation';
import Translation from '@s/Translation';
import EmbedFooter from '../../../components/EmbedFooter';
import { secondsTohhmmss } from '@b/helpers/time';
import { ReservationTimer } from '@v/checkout/components/ReservationTimer';
import { isDynamicListing } from '@b/checkout/selectors/dynamic-listing';
import { withFocusTrapContext } from '@b/checkout/contexts/FocusTrapContext';
import { focusTraps } from '@b/checkout/contexts/focusTraps';

class SeatingChartTicketPickerContainer extends Component {
    componentDidMount() {
      this.props.reactivateFocusTrap?.(focusTraps.TICKET_PICKER);
    }

    render() {
        return (
            <div className="tickets__content">
                <div className="tickets__content__main">
                    <ChangeDateContainer hideChangeButton={!!this.props.reservationActive}/>
                    <SeatsioChartContainer/>
                </div>
                <div className="tickets__content__side">
                    <div className="tickets-content-side__body">
                        <h2 className="tickets-content-side__header ticket__item"><Translation>{'checkout__confirm_or_edit_details'}</Translation></h2>
                        {this.props.reservationActive && <ReservationTimer time={this.props.time} />}
                        <SeatingChartCartInventory />
                        <ProductWrapper />
                    </div>
                    <div className="tickets-content-side__footer">
                        <SeatingChartTicketPickerTotals />
                        <InventoryErrors />
                        <FeeDisclosure />
                        <CheckoutButton />
                        <CouponEntryButton />
                        {!this.props.isDynamic && (<EmbedFooter />)}
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        reservationActive: reservationActive(state),
        time: secondsTohhmmss(state.reservation.time_remaining),
        isDynamic: isDynamicListing(state),
    };
};

export default connect(mapStateToProps)(withFocusTrapContext(SeatingChartTicketPickerContainer))
